// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Group, TextInput, Select } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

interface FilterConfig {
  key: string;
  label: string;
  options: { value: string; label: string }[];
  clearable?: boolean;
}

interface FilterBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  filters?: FilterConfig[];
  onFilterChange: (key: string, value: string) => void;
  filterValues: Record<string, string>;
  actions?: React.ReactNode;
}

export function FilterBar({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters,
  onFilterChange,
  filterValues,
  actions,
}: FilterBarProps) {
  return (
    <Group gap="sm" mb="md" wrap="wrap">
      <TextInput
        placeholder={searchPlaceholder}
        leftSection={<IconSearch size={16} />}
        value={searchValue}
        onChange={(e) => onSearchChange(e.currentTarget.value)}
        style={{ flex: 1, minWidth: 200 }}
      />
      {filters?.map((filter) => (
        <Select
          key={filter.key}
          placeholder={filter.label}
          data={filter.options}
          value={filterValues[filter.key] || null}
          onChange={(value) => onFilterChange(filter.key, value || '')}
          clearable={filter.clearable !== false}
          w={180}
        />
      ))}
      {actions && (
        <Group gap="sm" ml="auto">
          {actions}
        </Group>
      )}
    </Group>
  );
}

export type { FilterConfig };
